import React from 'react'
import { Box, Typography, Button, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import InfoCard from 'src/components/PostGraduationContent/PostgraduateComponents/Cards/InfoCard'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './IntroductionTab.styles'

const Introduction = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.intro.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        {[1, 2, 3, 4].map((num) => (
          <Typography key={num} className={classes.paragraph}>
            {t(`news.postgraduate.intro.p${num}`)}
          </Typography>
        ))}
      </Box>
      <Box className={classes.contentContainer}>
        <Box className={classes.cardGroup}>
          <InfoCard
            title={t('news.postgraduate.intro.info.edital')}
            description={t('news.postgraduate.intro.info.p2')}
          >
            <Link
              className={classes.buttonLink}
              href="https://drive.google.com/file/d/1g-S0_N6D9TCma0UHMhWJ-IAv0H54sKgY/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="contained" className={classes.button}>
                {t('news.postgraduate.intro.info.button')}
              </Button>
            </Link>

            <Link
              className={classes.buttonLink}
              href="https://drive.google.com/file/d/1PPWy2e1ois3NyM1VLgjjZznPpOQyw9NL/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="contained" className={classes.button}>
                {t('news.postgraduate.intro.info.button-add')}
              </Button>
            </Link>
          </InfoCard>
          <InfoCard
            title={t('news.postgraduate.sub.results.title')}
            description={t('news.postgraduate.sub.results.call')}
          >
            <Link
              className={classes.buttonLink}
              component={RouterLink}
              to="/postgraduate/rsc-2022/resultados"
            >
              <Button variant="contained" className={classes.button}>
                {t('news.postgraduate.sub.results.button')}
              </Button>
            </Link>
          </InfoCard>
        </Box>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.intro.info2.title')}
        </Typography>
        <AccentBox email="rsc@lsbd.ufc.br" />
      </Box>
    </>
  )
}

export default Introduction
